export default __webpack_public_path__ + "static/media/ans3.1d7451e2.png";